import React from 'react';
import { connect } from 'react-redux';
import * as StyledArticles from './articles.styles';
import pageWrapper from '../../hoc/pageWrapper';
import { fetchArticles } from '../../actions/articlesActions';
import useOnMount from '../../hooks/useOnMount';
import ArticleList from '../../components/articleList';

const Articles = ({
	dispatch,
	articlesReducer
}) => {
	const { articles, loading, error } = articlesReducer;

	useOnMount(() => {
		if(articles === null && !loading && !error) {
			dispatch(fetchArticles());
		}
	});

	return (
		<StyledArticles.Wrapper>
			<ArticleList
				articles={articles}
				loading={loading}
				error={error} />
		</StyledArticles.Wrapper>
	);
};

const mapStateToProps = (({ articlesReducer }) => ({
	articlesReducer
}));

export default connect(mapStateToProps, null)(pageWrapper(Articles));
